<template>
  <div class="flex-1 flex flex-col justify-between">
    <Form v-slot="{ values }" :initial-values="initial_values" :validation-schema="schema" @submit="createMetric">
      <SelectInput
        v-if="!objectType"
        v-model="object_type"
        :items="$store.state.object_types"
        name="object_type"
        label-attr="label"
        value-attr="type"
        :allow-null="false"
        :inline-label="true"
        :show-label="false"
        :classes="`w-[21vw] mb-2`"
        :is-box-background="true"
        :error="object_type_error"
        :label="$t('Custom Metric For')"
        :placeholder="$t('Select Object')" />
      <div class="max-h-full h-full mt-4">
        <div class="flex relative items-center space-x-4">
          <div class="flex-1 min-w-0">
            <div class="w-full gap-2 flex flex-col">
              <div class="w-full flex flex-row items-center gap-2">
                <div class="flex justify-between gap-2 w-full">
                  <TextInput
                    class="w-1/2 z-10"
                    :is-box-background="false"
                    :show-label="true"
                    :red-message="error_message"
                    :input-classes="[
                      error_message ? 'border border-status-error-red' : '',
                      'appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm'
                    ]"
                    name="name"
                    type="text"
                    :label="$t('Name')"
                    @input="error_message = null" />
                  <!--  <ComboBoxInput
                    :items="$store.state.data.metrics_tags"
                    name="metric_tag"
                    classes="w-1/3 relative dark:text-white"
                    label-attr="label"
                    value-attr="value"
                    :is-box-background="true"
                    :label="$t('Metric Tag')"
                    :show-label="true"
                    :floating-label="true"
                    :allow-null="true" /> -->
                </div>
                <SelectInput
                  :items="metrics_types"
                  label-attr="label"
                  value-attr="value"
                  :allow-null="false"
                  name="is_public"
                  :placeholder="$t('Type')"
                  :is-box-background="true"
                  :show-label="true"
                  :label="$t('Type')"
                  classes="w-1/2"
                  input-classes="appearance-none text-left block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm bg-white focus:ring-1 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm" />
                <SelectInput
                  name="input_type"
                  :items="input_types"
                  label-attr="label"
                  value-attr="value"
                  :allow-null="false"
                  :is-box-background="true"
                  :show-label="true"
                  :label="$t('Field type')"
                  classes="w-1/2"
                  input-classes="appearance-none dark:text-dark-body-text text-left block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm bg-white focus:ring-1 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm" />

                <SelectInput
                  v-if="values.input_type == 'Currency'"
                  :items="$consts.currencies.data"
                  label-attr="label"
                  value-attr="value"
                  :allow-null="false"
                  name="currency"
                  :placeholder="$t('Currency type')"
                  :is-box-background="true"
                  :show-label="true"
                  :label="$t('Currency')"
                  classes="w-full"
                  input-classes="appearance-none text-left block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm bg-white focus:ring-1 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm" />
                <SelectInput
                  v-if="values.input_type == 'Decimal'"
                  :items="[
                    { label: 1, value: 1 },
                    { label: 2, value: 2 },
                    { label: 3, value: 3 },
                    { label: 4, value: 4 }
                  ]"
                  label-attr="label"
                  value-attr="value"
                  :allow-null="false"
                  name="decimal_places"
                  :placeholder="$t('Decimal Places')"
                  :is-box-background="true"
                  :show-label="true"
                  :label="$t('Decimal Places')"
                  classes="w-full"
                  input-classes="appearance-none text-left block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm bg-white focus:ring-1 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm" />
                <div v-if="values.input_type == 'Number' || values.input_type == 'Currency'" class="flex justify-between">
                  <div class="mt-2 text-common-grey">
                    {{ $t("Truncate") }}:
                  </div>
                  <input
                    v-model="new_metric.truncate"
                    :checked="values.truncate"
                    type="checkbox"
                    name="truncate"
                    class="ml-2 mt-2 form-checkbox text-light-brand-blue dark:text-dark-brand-blue checked:bg-light-brand-blue dark:checked:bg-dark-brand-blue bg-light-box-background dark:bg-dark-box-background border-[2px] focus:ring-0 ring-dark/0 border-common-grey w-5 rounded h-5 transition ease-in-out duration-side-menu-transition-duration">
                </div>
              </div>
              <div class="w-full flex flex-col gap-1">
                <div
                  v-if="
                    values.input_type == 'List' ||
                      values.input_type == 'Select' ||
                      values.input_type == 'Checklist' ||
                      values.input_type == 'BulletPointsList' ||
                      values.input_type == 'OrderedList'
                  "
                  class="flex w-full justify-start items-center gap-2 mb-2">
                  <TextInput
                    name="option"
                    :value="option"
                    label=""
                    :classes="'w-full'"
                    input-classes="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm"
                    type="text"
                    :placeholder="$t('Type the option than click Add')"
                    @keyup.enter="addOption"
                    @input="
                      ($event) => {
                        option = $event.target.value
                      }
                    " />

                  <!-- <input
                    v-model="option"
                    name="option"
                    type="text"
                    placeholder="Type the option than click Add"
                    classes=""
                    class="w-3/4 appearance-none block px-3 py-2 bg-light-box-background dark:bg-dark-box-background border-light-divider-border dark:border-dark-divider-border rounded-md text-light-body-text dark:text-dark-body-text shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm"> -->
                  <button :class="{ 'pointer-events-none opacity-60': loading }" class="primary-btn w-1/4" @click.prevent="addOption">
                    {{ loading ? $t("Loading...") : $t("Add") }}
                  </button>
                </div>
                <div v-if="options.length > 0" class="text-light-body-text dark:text-dark-body-text">
                  <ul>
                    <li v-for="(item, index) in options" :key="index" class="ml-2 sm:text-sm">
                      {{ item }}
                    </li>
                  </ul>
                </div>
              </div>
              <TextArea name="description" :label="$t('Description')" @input="new_metric.description = $event.target.value" />
            </div>
          </div>
        </div>
      </div>

      <div class="flex gap-2 -mt-2 w-full flex-row justify-between">
        <button type="button" class="cancel-btn w-1/2 m-0" @click="$emit('cancel')">{{ $t("Cancel") }}</button>
        <button type="submit" :class="{ 'pointer-events-none opacity-60': loading }" class="primary-btn w-1/2">
          {{ loading ? $t("Loading...") : $t("Add") }}
        </button>
      </div>
    </Form>
  </div>
</template>

<script>
import * as Yup from "yup"
import TextInput from "@/components/shared/TextInput.vue"
import SelectInput from "@/components/shared/SelectInput.vue"
// import ComboBoxInput from "@/components/shared/ComboBoxInput.vue"
import TextArea from "@/components/shared/TextArea.vue"
import { Form } from "vee-validate"
import { ALL_EMITTERS } from "@/store/constants/all_emitters"
export default {
  components: {
    Form,
    TextArea,
    SelectInput,
    // ComboBoxInput,
    TextInput
  },
  props: {
    objectType: {
      type: String,
      default: null,
      required: false
    }
  },
  emits: ["cancel", "submitted", "done"],

  data() {
    return {
      loading: false,
      error_message: null,
      object_type_error: "",
      schema: null,
      initial_values: null,
      object_type: null,
      options: [],
      option: "",
      new_metric: {
        name: "",
        metric_class: "custom_metric",
        object_type: this.object_type,
        formula: [],
        is_public: "t",
        description: "",
        truncate: true,
        decimal_places: 2,
        currency: this.$t("USD")
      },
      metrics_types: [
        { label: this.$t("Public"), value: "t" },
        { label: this.$t("Private (Me)"), value: "f" }
      ],
      input_types: [
        { label: this.$t("Checkbox"), value: "Checkbox" },
        { label: this.$t("Number"), value: "Number" },
        { label: this.$t("Decimal"), value: "Decimal" },
        { label: this.$t("Percent"), value: "Percent" },
        { label: this.$t("Currency"), value: "Currency" },
        { label: this.$t("Text"), value: "Text" },
        { label: this.$t("Textarea"), value: "Textarea" },
        { label: this.$t("RichTextarea"), value: "RichTextarea" },
        { label: this.$t("Email"), value: "Email" },
        { label: this.$t("URL"), value: "URL" },
        { label: this.$t("Time"), value: "Time" },
        { label: this.$t("Date"), value: "Date" },
        { label: this.$t("Date Time"), value: "DateTime" },
        { label: this.$t("Select"), value: "Select" },
        { label: this.$t("Checklist"), value: "Checklist" },
        { label: this.$t("Bullet points list"), value: "BulletPointsList" },
        { label: this.$t("Ordered list"), value: "OrderedList" },
        { label: this.$t("Bar rating"), value: "BarRating" },
        { label: this.$t("Star rating"), value: "StarRating" }
      ]
    }
  },
  watch: {
    object_type() {
      this.object_type_error = ""
    }
  },
  created() {
    this.object_type = this.objectType
    this.schema = Yup.object().shape({
      name: Yup.string().required(this.$t("Name is required")),
      description: Yup.string(),
      is_public: Yup.mixed().oneOf(["t", "f"]),
      input_type: Yup.string().required(this.$t("Input type is required"))
    })

    this.initial_values = {
      name: "",
      metric_class: "custom_metric",
      object_type: this.object_type,
      input_type: this.input_types[5].value,
      formula: [],
      is_public: "t",
      description: "",
      truncate: true,
      decimal_places: 2,
      currency: this.$t("USD")
    }
  },

  methods: {
    addOption() {
      if (this.option != null && this.option != " ") {
        this.options.push(this.option)
      }
      this.option = null
    },

    createMetric(values) {
      if (!values.object_type) {
        this.object_type_error = this.$t("Object type required")
      }
      if (values.name.toLowerCase().includes("renewal date")) {
        this.error_message = this.$t("Restricted name")
      }
      if (!this.error_message && !this.object_type_error) {
        values.input_options = {}
        if (
          values.input_type == "Select" ||
          values.input_type == "Checklist" ||
          values.input_type == "BulletPointsList" ||
          values.input_type == "OrderedList"
        ) {
          values.input_options = { choices: this.options }
        } else if (values.input_type == "Boolean") {
          values.input_options = { choices: [true, false] }
        } else if (values.input_type == "BarRating") {
          values.input_options = { choices: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10] }
        } else if (values.input_type == "StarRating") {
          values.input_options = { choices: [0, 1, 2, 3, 4, 5] }
        }

        values.input_options.currency = values.currency
        values.input_options.truncate = this.new_metric.truncate
        values.input_options.decimal_places = values.decimal_places
        this.loading = true
        this.$store
          .dispatch("data/addMetric", values)
          .then((res) => {
            if (res) {
              this.loading = false
              // this.$store.commit("addMetric", res)
              this.$emitter.emit(ALL_EMITTERS.CUSTOM_METRIC_ADDED_IN_OVERVIEW_COMPONENT, res)
              this.$emitter.emit(ALL_EMITTERS.CUSTOM_METRIC_ADDED_IN_METRICS, res)
              this.$emitter.emit(ALL_EMITTERS.RELOAD_METRICS_AND_SOURCES, res)

              this.$emit("done")
            } else {
              this.loading = false
              this.error_message = this.$t("Metric name already in use")
            }
          })
          .catch(() => {
            this.loading = false
            this.error_message = this.$t("Metric name already in use")
          })
      }
    }
  }
}
</script>
